import React, { useState, useEffect, useRef } from 'react';
import { verifyPinRemote, _settlePin } from '../lib/pin-guard.js';

/** Fenêtre globale de re-saisie du PIN (déclenchée par requirePin). */
export default function PinGuardModal({ user }) {
  const [req, setReq] = useState(null); // { label }
  const [pin, setPin] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    const on = (e) => { setReq({ label: e.detail?.label || '' }); setPin(''); setErr(''); setTimeout(() => inputRef.current?.focus(), 50); };
    window.addEventListener('elixir:pin-request', on);
    return () => window.removeEventListener('elixir:pin-request', on);
  }, []);

  if (!req) return null;
  const cancel = () => { setReq(null); _settlePin(false); };
  const submit = async () => {
    if (pin.length !== 4) { setErr('4 chiffres'); return; }
    setBusy(true); setErr('');
    const r = await verifyPinRemote(pin);
    setBusy(false);
    if (r.ok) { setReq(null); _settlePin(true); }
    else { setErr(r.error || 'Code incorrect'); setPin(''); inputRef.current?.focus(); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', zIndex: 99998, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }} onClick={cancel}>
      <div onClick={e => e.stopPropagation()} style={{ background: 'white', borderRadius: 14, padding: 18, width: '100%', maxWidth: 360, boxShadow: '0 10px 30px rgba(0,0,0,.3)' }}>
        <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 4 }}>🔐 Confirme ton code</div>
        <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 12 }}>
          {req.label ? req.label + ' — ' : ''}cette action est enregistrée au nom de <b>{user?.name}</b>. Si ce n'est pas toi, annule et connecte-toi avec ton compte.
        </div>
        <input ref={inputRef} type="password" inputMode="numeric" pattern="[0-9]*" maxLength={4} value={pin}
          onChange={e => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
          onKeyDown={e => { if (e.key === 'Enter') submit(); if (e.key === 'Escape') cancel(); }}
          placeholder="••••" style={{ width: '100%', padding: 12, fontSize: 24, textAlign: 'center', letterSpacing: 12, borderRadius: 10, border: '1.5px solid ' + (err ? '#C0392B' : '#E5E7EB'), boxSizing: 'border-box', fontFamily: 'inherit' }} />
        {err && <div style={{ color: '#C0392B', fontSize: 12, marginTop: 6, fontWeight: 600 }}>{err}</div>}
        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
          <button onClick={cancel} style={{ flex: 1, padding: 11, borderRadius: 9, border: '1.5px solid #E5E7EB', background: 'white', color: '#6B7280', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Annuler</button>
          <button onClick={submit} disabled={busy} style={{ flex: 1, padding: 11, borderRadius: 9, border: 'none', background: busy ? '#9CA3AF' : '#1A5276', color: 'white', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>{busy ? '…' : 'Valider'}</button>
        </div>
      </div>
    </div>
  );
}
